import React from "react";
import { Grid, Theme } from "@material-ui/core";
import { ArrayInput, SimpleFormIterator, TextInput, email } from "react-admin";
import "./NotificationRecipientsSelector.css";
import { AppState } from "../../../common/types";
import { useTheme } from "@material-ui/styles";
import { useSelector } from "react-redux";
import { PhoneNumberInput } from "../../common/form/PhoneNumberInput";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";

interface Props {}

export const NotificationRecipientsSelector = (props: Props) => {
  const themeName = useSelector((x: AppState) => x.theme);
  const theme: Theme = useTheme();
  return (
    <Grid container className="full-width-container">
      <ProtectedElement source="emailRecipients">
        <Grid
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="full-width-container-item"
          style={{
            borderColor:
              themeName === "dark"
                ? theme.palette.grey[600]
                : theme.palette.grey[400],
          }}>
          <ArrayInput
            {...props}
            source="emailRecipients"
            label="resources.admin-notifications.labels.emailRecipients">
            <SimpleFormIterator className="simple-form-iterator">
              <TextInput
                source=""
                label="resources.admin-notifications.labels.email"
                validate={email()}
              />
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      </ProtectedElement>
      <ProtectedElement source="smsRecipients">
        <Grid
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="full-width-container-item"
          style={{
            borderColor:
              themeName === "dark"
                ? theme.palette.grey[600]
                : theme.palette.grey[400],
          }}>
          <ArrayInput
            {...props}
            source="smsRecipients"
            label="resources.admin-notifications.labels.smsRecipients">
            <SimpleFormIterator className="simple-form-iterator">
              <PhoneNumberInput
                source=""
                label="resources.admin-notifications.labels.smsNumber"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      </ProtectedElement>
    </Grid>
  );
};
